import * as types from 'store/types';
import { update } from 'variables/utilities';

const initial = {
  preferences: null, request: null,
	loading: false
};

const started = (state, action) => {
	return update( state, {
		request: action.request,
		error: null, loading: true
	});
};

const succeeded = (state, action) => {
	const businesses = action.businesses ? action.businesses : state.businesses;
	const filtered = action.business ? 
										businesses.filter((business) => business.businessId !== action.business.businessId) :
										businesses;
	return update( state, {
		businesses: filtered,
    business: action.business ? action.business : state.business,
		loading: false, modifiedDate: new Date(),
	});
};

const failed = (state, action) => {
	return update( state, {
			error: action.error, loading: false
	});
}

const businesses = (state = initial, action) => {
	switch ( action.type ) {
		case types.BUSINESS_START: 
			return started(state, action);

		case types.BUSINESS_SUCCESS: 
			return succeeded(state, action);

		case types.BUSINESS_FAILURE: 
			return failed(state, action);

		default:
			return state;
	}
};

export default businesses;